import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";

export default function ClientNameChoiceDialog({ open, onOpenChange, currentName, companyName, onConfirm }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-h-[calc(100dvh-2rem)] w-[calc(100%-2rem)] max-w-lg overflow-y-auto rounded-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle>Alterar nome do cliente?</AlertDialogTitle>
          <AlertDialogDescription>
            Ao vincular a empresa, você deseja manter o nome atual do cliente ou usar o nome da empresa?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="min-w-0 space-y-3 text-sm">
          <div className="rounded-lg border bg-gray-50 p-3">
            <p className="text-xs font-medium text-gray-500">Nome atual do cliente</p>
            <p className="mt-1 font-semibold text-gray-900 [overflow-wrap:anywhere]">{currentName || "Sem nome"}</p>
          </div>
          <div className="rounded-lg border border-blue-200 bg-blue-50 p-3">
            <p className="text-xs font-medium text-blue-600">Nome da empresa</p>
            <p className="mt-1 font-semibold text-blue-900 [overflow-wrap:anywhere]">{companyName}</p>
          </div>
        </div>
        <AlertDialogFooter className="gap-2 sm:space-x-0">
          <AlertDialogCancel className="mt-0" onClick={(event) => { event.preventDefault(); onConfirm(false); }}>Manter nome atual</AlertDialogCancel>
          <AlertDialogAction className="bg-blue-600 hover:bg-blue-700" onClick={(event) => { event.preventDefault(); onConfirm(true); }}>Usar nome da empresa</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
